/* VIVAX — JS custom consolidado (2026-09-06). Cargado con defer desde theme.liquid.
   Cada bloque es un IIFE con su propio guard; el orden no importa. */

/* ── chat widget ── */
(function () {
    var WORKER_BASE = 'https://vivax-chat-agente.vivax-mx.workers.dev';
    var WORKER_URL = WORKER_BASE + '/chat';
    var widget = document.getElementById('vivax-chat-widget');
    var toggle = document.getElementById('vivax-chat-toggle');
    var panel = document.getElementById('vivax-chat-panel');
    var messagesEl = document.getElementById('vivax-chat-messages');
    var form = document.getElementById('vivax-chat-form');
    var input = document.getElementById('vivax-chat-input');
    var closeBtn = document.getElementById('vivax-chat-close');

    var CLAVE_SESION = 'vivax_chat_session';
    var CLAVE_ACTIVIDAD = 'vivax_chat_ultima_actividad';
    var CLAVE_ABIERTO = 'vivax_chat_abierto';
    // Si el visitante vuelve después de este tiempo, empieza una conversación
    // nueva en vez de revivir una charla vieja que ya no viene al caso.
    var HORAS_VIGENCIA = 24;

    function getSessionId() {
      var id = null;
      try {
        id = localStorage.getItem(CLAVE_SESION);
        var ultima = parseInt(localStorage.getItem(CLAVE_ACTIVIDAD) || '0', 10);
        var vencida = ultima && (Date.now() - ultima) > HORAS_VIGENCIA * 3600 * 1000;
        if (id && vencida) {
          id = null; // conversación caducada: arrancamos limpio
          localStorage.removeItem(CLAVE_ABIERTO);
        }
        if (!id) {
          id = 'sess_' + Math.random().toString(36).slice(2) + Date.now();
          localStorage.setItem(CLAVE_SESION, id);
        }
        localStorage.setItem(CLAVE_ACTIVIDAD, String(Date.now()));
      } catch (e) {
        // Si el navegador bloquea localStorage (modo privado estricto),
        // seguimos funcionando con una sesión temporal en memoria.
        id = id || 'sess_temp_' + Math.random().toString(36).slice(2);
      }
      return id;
    }

    function recordarAbierto(abierto) {
      try {
        if (abierto) localStorage.setItem(CLAVE_ABIERTO, '1');
        else localStorage.removeItem(CLAVE_ABIERTO);
      } catch (e) {}
    }

    function estabaAbierto() {
      try { return localStorage.getItem(CLAVE_ABIERTO) === '1'; } catch (e) { return false; }
    }

    /* ---------- Efectos de sonido ----------
       Se generan con Web Audio API (sin archivos MP3): no pesan nada, no hay
       que descargar nada y suenan al instante. Si el navegador no lo soporta
       o bloquea el audio, simplemente no suena — nunca rompe el chat. */
    var audioCtx = null;

    function iniciarAudio() {
      try {
        if (!audioCtx) {
          var AC = window.AudioContext || window.webkitAudioContext;
          if (!AC) return null;
          audioCtx = new AC();
        }
        // iOS/Safari suspenden el audio hasta que hay un gesto del usuario
        if (audioCtx.state === 'suspended') audioCtx.resume();
        return audioCtx;
      } catch (e) {
        return null;
      }
    }

    function tono(freqInicio, freqFin, duracion, volumen, retraso) {
      var ctx = iniciarAudio();
      if (!ctx) return;
      try {
        var t0 = ctx.currentTime + (retraso || 0);
        var osc = ctx.createOscillator();
        var gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(freqInicio, t0);
        if (freqFin && freqFin !== freqInicio) {
          osc.frequency.exponentialRampToValueAtTime(freqFin, t0 + duracion);
        }
        // Envolvente suave: sube rápido y baja en curva, así no truena al cortar
        gain.gain.setValueAtTime(0.0001, t0);
        gain.gain.exponentialRampToValueAtTime(volumen, t0 + 0.012);
        gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duracion);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(t0);
        osc.stop(t0 + duracion + 0.03);
      } catch (e) {
        /* si algo falla con el audio, seguimos sin sonido */
      }
    }

    // "Pop" corto y ascendente al mandar el mensaje
    function sonidoEnviar() {
      tono(420, 720, 0.11, 0.14, 0);
    }

    // Dos notas tipo campanita al llegar la respuesta
    function sonidoRecibir() {
      tono(880, 880, 0.09, 0.10, 0);
      tono(1170, 1170, 0.13, 0.10, 0.085);
    }

    function addMessage(role, text) {
      var el = document.createElement('div');
      el.className = 'vivax-chat-msg ' + role;
      el.textContent = text;
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return el;
    }

    // Burbuja con los 3 puntitos animados mientras el bot "escribe"
    function addTyping() {
      var el = document.createElement('div');
      el.className = 'vivax-chat-msg model';
      el.innerHTML = '<span class="vivax-chat-typing"><span></span><span></span><span></span></span>';
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return el;
    }

    // Chips de sugerencias: arrancan la conversación con un toque
    var SUGERENCIAS = ['¿Qué producto me recomiendas?', 'Precios y promociones', 'Envíos y pagos'];
    function mostrarChips() {
      if (document.getElementById('vivax-chat-chips')) return;
      var wrap = document.createElement('div');
      wrap.className = 'vivax-chat-chips';
      wrap.id = 'vivax-chat-chips';
      SUGERENCIAS.forEach(function (t) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vivax-chat-chip';
        b.textContent = t;
        b.addEventListener('click', function () { enviarMensaje(t); });
        wrap.appendChild(b);
      });
      messagesEl.appendChild(wrap);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }
    function ocultarChips() {
      var c = document.getElementById('vivax-chat-chips');
      if (c) c.remove();
    }

    var greeted = false;
    var historialCargado = false;
    var cargandoHistorial = false;
    var enviando = false;

    /* Recupera la conversación previa desde el servidor.
       El session_id vive en localStorage, así que al cambiar de página el
       visitante sigue siendo "el mismo" y el chat continúa donde se quedó. */
    function cargarHistorial(alTerminar) {
      if (historialCargado || cargandoHistorial) {
        if (alTerminar) alTerminar();
        return;
      }
      cargandoHistorial = true;

      fetch(WORKER_BASE + '/history', {
        method: 'GET',
        headers: { 'X-Vivax-Session': getSessionId() },
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var msgs = (data && data.messages) || [];
          if (msgs.length) {
            msgs.forEach(function (m) {
              addMessage(m.role === 'user' ? 'user' : 'model', m.text);
            });
            greeted = true; // ya hay conversación: no repetimos el saludo
          }
        })
        .catch(function () {
          /* si no se pudo recuperar, simplemente empieza limpio */
        })
        .finally(function () {
          historialCargado = true;
          cargandoHistorial = false;
          if (alTerminar) alTerminar();
        });
    }

    function abrirPanel(conFoco) {
      widget.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-label', 'Cerrar chat');
      recordarAbierto(true);
      cargarHistorial(function () {
        // Solo saludamos si la ventana está realmente vacía: si el visitante
        // alcanzó a escribir mientras cargaba el historial, el saludo
        // aparecería fuera de orden debajo de su mensaje.
        if (!greeted && messagesEl.children.length === 0) {
          greeted = true;
          addMessage('model', '¡Hola! Soy el asistente de VIVAX 🌿 ¿En qué te puedo ayudar hoy?');
          mostrarChips();
        }
        messagesEl.scrollTop = messagesEl.scrollHeight;
      });
      if (conFoco) setTimeout(function () { input.focus(); }, 200);
    }

    function cerrarPanel() {
      widget.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-label', 'Abrir chat');
      recordarAbierto(false);
    }

    toggle.addEventListener('click', function () {
      if (widget.classList.contains('is-open')) {
        cerrarPanel();
      } else {
        iniciarAudio(); // este clic es el gesto que iOS necesita para el audio
        abrirPanel(true);
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', function () { cerrarPanel(); });

    /* Si el visitante venía con el chat abierto, lo dejamos abierto al
       cambiar de página — pero sin robarle el foco al teclado. */
    if (estabaAbierto()) {
      abrirPanel(false);
    }

    // Envío de un mensaje (lo usan el formulario y los chips de sugerencia)
    function enviarMensaje(text) {
      text = (text || '').trim();
      if (!text || enviando) return;
      enviando = true;

      ocultarChips();
      sonidoEnviar();
      addMessage('user', text);
      input.value = '';
      input.disabled = true;

      var typingEl = addTyping();

      fetch(WORKER_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Vivax-Session': getSessionId(),
        },
        body: JSON.stringify({ message: text }),
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          typingEl.remove();
          sonidoRecibir();
          if (data.reply) {
            addMessage('model', data.reply);
          } else {
            addMessage('model', 'Ups, algo salió mal. ¿Puedes reformular tu pregunta?');
          }
        })
        .catch(function () {
          typingEl.remove();
          addMessage('model', 'No pude conectar en este momento. Intenta de nuevo en unos segundos.');
        })
        .finally(function () {
          enviando = false;
          input.disabled = false;
          input.focus();
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      enviarMensaje(input.value);
    });
  })();

/* ── popup descuento ── */
(function(){
    if (window.__vivaxPopInit) return;
    window.__vivaxPopInit = true;
    var KEY = 'vivax_pop_seen', DAYS = 7;
    function seenRecently(){
      try { var t = parseInt(localStorage.getItem(KEY) || '0', 10);
        return t && (Date.now() - t) < DAYS*24*60*60*1000; } catch(e){ return false; }
    }
    function markSeen(){ try { localStorage.setItem(KEY, String(Date.now())); } catch(e){} }
    var pop = document.getElementById('VivaxPop');
    if (!pop) return;
    // bloqueo de scroll del fondo (robusto para iOS: fija el body y restaura la posición al cerrar)
    var _scrollY = 0;
    function lockScroll(){
      try {
        _scrollY = window.scrollY || window.pageYOffset || 0;
        var b = document.body;
        b.style.position = 'fixed'; b.style.top = (-_scrollY) + 'px';
        b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
        b.style.overflow = 'hidden';
      } catch(e){}
    }
    function unlockScroll(){
      try {
        var b = document.body;
        b.style.position = ''; b.style.top = ''; b.style.left = '';
        b.style.right = ''; b.style.width = ''; b.style.overflow = '';
        window.scrollTo(0, _scrollY);
      } catch(e){}
    }
    function open(){ pop.hidden = false; lockScroll(); }
    function close(){ pop.hidden = true; unlockScroll(); markSeen(); }
    function showDone(){
      var f = pop.querySelector('[data-pop-view="form"]'), d = pop.querySelector('[data-pop-view="done"]');
      if (f) f.hidden = true; if (d) d.hidden = false;
    }
    // ⏳ contador SUAVE hasta fin de mes: se recalcula solo, así se "reinicia" el día 1 sin tocar nada
    var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
    function pad2(n){ return (n < 10 ? '0' : '') + n; }
    function tickTimer(){
      var ahora = new Date();
      var fin = new Date(ahora.getFullYear(), ahora.getMonth() + 1, 0, 23, 59, 59, 999); // último día del mes actual
      var diff = fin - ahora; if (diff < 0) diff = 0;
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      var reloj = (d > 0 ? d + 'd ' : '') + pad2(h) + ':' + pad2(m) + ':' + pad2(s);
      var fecha = fin.getDate() + ' de ' + MESES[fin.getMonth()];
      pop.querySelectorAll('[data-pop-reloj]').forEach(function(el){ el.textContent = reloj; });
      pop.querySelectorAll('[data-pop-fecha]').forEach(function(el){ el.textContent = fecha; });
    }
    tickTimer();
    setInterval(tickTimer, 1000);
    // close handlers
    pop.querySelectorAll('[data-pop-close]').forEach(function(el){ el.addEventListener('click', close); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !pop.hidden) close(); });
    // copy code — robusto para iOS Safari (Clipboard API + fallback execCommand)
    var copyBtn = pop.querySelector('[data-pop-copy]');
    function fallbackCopy(text){
      try {
        var el = document.createElement('textarea');
        el.value = text;
        el.setAttribute('readonly', '');
        el.style.position = 'fixed'; el.style.top = '0'; el.style.left = '-9999px';
        document.body.appendChild(el);
        // iOS necesita contentEditable + rango de selección explícito
        var prevCE = el.contentEditable, prevRO = el.readOnly;
        el.contentEditable = 'true'; el.readOnly = false;
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges(); sel.addRange(range);
        el.setSelectionRange(0, text.length);
        el.contentEditable = prevCE; el.readOnly = prevRO;
        var ok = false; try { ok = document.execCommand('copy'); } catch(e){}
        document.body.removeChild(el);
        return ok;
      } catch(e){ return false; }
    }
    function flashCopied(ok){
      copyBtn.textContent = ok ? '¡Copiado!' : 'Cópialo 👆';
      setTimeout(function(){ copyBtn.textContent = 'Copiar'; }, 2200);
    }
    if (copyBtn) copyBtn.addEventListener('click', function(){
      var code = ((pop.querySelector('[data-pop-code]')||{}).textContent || 'BIENVENIDA15').trim();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function(){ flashCopied(true); })
          .catch(function(){ flashCopied(fallbackCopy(code)); });
      } else {
        flashCopied(fallbackCopy(code));
      }
    });
    // form submit -> submit NATIVO (Shopify crea el cliente y recarga); marcamos para mostrar el código al volver
    var form = document.getElementById('VivaxPopForm');
    if (form) form.addEventListener('submit', function(){
      var input = form.querySelector('input[name="contact[email]"]');
      if (input && !input.value) return; // deja que la validación 'required' actúe
      try { localStorage.setItem('vivax_pop_done', '1'); } catch(e){}
      markSeen();
      // sin preventDefault: el navegador hace el POST nativo a /contact
    });

    // ¿venimos de un envío exitoso? -> abrir directo en la vista del código
    var justDone = false;
    try { justDone = localStorage.getItem('vivax_pop_done') === '1'; } catch(e){}
    // Si el envío fue del "Avísame cuando llegue" (misma forma 'customer' de Shopify → mismo
    // ?customer_posted=true), NO abrir este popup: ya dejó su correo y le toca ver SU confirmación.
    var deAvisame = location.hash === '#VivaxAvisame';
    try { deAvisame = deAvisame || localStorage.getItem('vivax_avisame_pending') === '1'; } catch(e){}
    if (deAvisame && !justDone) {
      markSeen();
    } else if (justDone || location.search.indexOf('customer_posted=true') >= 0) {
      try { localStorage.removeItem('vivax_pop_done'); } catch(e){}
      showDone();
      open();
    } else if (!seenRecently()) {
      setTimeout(open, 4500);
    }
  })();

/* ── marquesina ── */
(function () {
    var marquesina = document.querySelector('.vivax-marquesina');
    if (!marquesina) return;
    var pista = marquesina.querySelector('.vivax-marquesina__pista');
    var original = pista.querySelector('.vivax-marquesina__grupo');
    if (!pista || !original) return;

    // Velocidad constante en píxeles por segundo. Bajarlo = más lento.
    var VELOCIDAD = 26;

    function armar() {
      // Dejar solo el grupo original para volver a medir limpio
      while (pista.children.length > 1) pista.removeChild(pista.lastChild);

      var anchoGrupo = original.getBoundingClientRect().width;
      if (!anchoGrupo) return;

      /* El problema que esto resuelve: la animación desplaza exactamente el
         ancho de un "ciclo". Si ese ciclo mide menos que la pantalla, al
         terminar queda un hueco vacío y se ve el salto. Repetimos el grupo
         hasta que el ciclo sea al menos tan ancho como la ventana. */
      var copiasPorCiclo = Math.max(1, Math.ceil(window.innerWidth / anchoGrupo));

      var fragmento = document.createDocumentFragment();
      // Completar el primer ciclo...
      for (var i = 1; i < copiasPorCiclo; i++) {
        var extra = original.cloneNode(true);
        extra.setAttribute('aria-hidden', 'true');
        fragmento.appendChild(extra);
      }
      // ...y duplicarlo entero, que es lo que hace invisible el reinicio.
      for (var j = 0; j < copiasPorCiclo; j++) {
        var copia = original.cloneNode(true);
        copia.setAttribute('aria-hidden', 'true');
        fragmento.appendChild(copia);
      }
      pista.appendChild(fragmento);

      var anchoCiclo = anchoGrupo * copiasPorCiclo;
      pista.style.setProperty('--vivax-marq-duracion', (anchoCiclo / VELOCIDAD).toFixed(1) + 's');
    }

    // Esperar a que carguen las fuentes: si medimos antes, el ancho cambia
    // después y el cálculo queda mal.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(armar);
    } else {
      armar();
    }

    var temporizador;
    window.addEventListener('resize', function () {
      clearTimeout(temporizador);
      temporizador = setTimeout(armar, 250);
    });
  })();

/* ── selector cantidad ── */
(function () {
      var bloque = document.querySelector('[data-vivax-volumen]');
      if (!bloque) return;

      // El campo de cantidad del formulario de compra
      function campoCantidad() {
        return document.querySelector('.product-form__input input[name="quantity"]')
          || document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      }

      bloque.addEventListener('change', function (e) {
        if (!e.target.matches('input[name="vivax-volumen-op"]')) return;
        var campo = campoCantidad();
        if (!campo) return;
        campo.value = e.target.value;
        // Avisar al tema que la cantidad cambió, por si escucha el evento
        campo.dispatchEvent(new Event('change', { bubbles: true }));
      });
    })();

/* ── hero parallax (home) ── */
(function(){
    function init(root){
      if(root.__vhx) return; root.__vhx=true;
      var slides=[].slice.call(root.querySelectorAll('[data-vhx-slide]'));
      if(slides.length<1) return;
      var dotsWrap=root.querySelector('[data-vhx-dots]');
      var rm=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(rm) root.classList.add('vhx--rm');
      var i=0;
      for(var k=0;k<slides.length;k++){ if(slides[k].classList.contains('is-active')){ i=k; break; } }
      slides[i].classList.add('is-active');

      /* Orbes grandes y suaves de ambiente (morados profundos) que derivan lento
         por el fondo. El destello principal es el aura detrás del producto. */
      if(!rm){
        var ORB=[
          'radial-gradient(circle,rgba(139,63,194,.5) 0%,rgba(91,31,138,.22) 45%,transparent 72%)',
          'radial-gradient(circle,rgba(217,70,174,.42) 0%,rgba(139,63,194,.18) 45%,transparent 72%)'
        ];
        slides.forEach(function(s){
          var fx=document.createElement('div'); fx.className='vhx__fx';
          for(var q=0;q<5;q++){
            var o=document.createElement('span'); o.className='vhx__spark';
            var size=(90+Math.random()*130).toFixed(0);
            o.style.width=size+'px'; o.style.height=size+'px';
            o.style.left=(Math.random()*100).toFixed(2)+'%';
            o.style.top=(Math.random()*100).toFixed(2)+'%';
            o.style.background=ORB[q%ORB.length];
            o.style.filter='blur(26px)';
            o.style.setProperty('--o',(0.30+Math.random()*0.30).toFixed(2));
            o.style.setProperty('--d',(7+Math.random()*5).toFixed(1)+'s');
            o.style.setProperty('--dy',(14+Math.random()*9).toFixed(1)+'s');
            o.style.setProperty('--dx',((Math.random()*2-1)*20).toFixed(1)+'px');
            o.style.setProperty('--delay','-'+(Math.random()*9).toFixed(1)+'s');
            fx.appendChild(o);
          }
          s.insertBefore(fx, s.querySelector('.vhx__inner'));
        });
      }
      var dots=slides.map(function(s,idx){
        var b=document.createElement('button');
        b.type='button';
        b.className='vhx__dot'+(idx===i?' is-active':'');
        b.setAttribute('aria-label','Ir al slide '+(idx+1));
        b.addEventListener('click',function(){ go(idx,true); });
        if(dotsWrap) dotsWrap.appendChild(b);
        return b;
      });
      function go(n,manual){
        n=(n+slides.length)%slides.length;
        if(n===i) return;
        slides[i].classList.remove('is-active'); if(dots[i]) dots[i].classList.remove('is-active');
        i=n;
        slides[i].classList.add('is-active'); if(dots[i]) dots[i].classList.add('is-active');
        if(manual) restart();
      }
      var spd=(parseFloat(root.getAttribute('data-autoplay'))||6)*1000;
      var timer=null;
      function start(){ if(rm||slides.length<2) return; stop(); timer=setInterval(function(){ go(i+1); },spd); }
      function stop(){ if(timer){ clearInterval(timer); timer=null; } }
      function restart(){ stop(); start(); }
      var next=root.querySelector('[data-vhx-next]'), prev=root.querySelector('[data-vhx-prev]');
      if(next) next.addEventListener('click',function(){ go(i+1,true); });
      if(prev) prev.addEventListener('click',function(){ go(i-1,true); });
      root.addEventListener('mouseenter',stop);
      root.addEventListener('mouseleave',start);
      document.addEventListener('visibilitychange',function(){ document.hidden?stop():start(); });
      start();

      /* Flotación ORGÁNICA (no repetitiva): rAF con suma de senoidales de
         frecuencias distintas por eje → sube/baja/gira con montos variables,
         suave tipo gravedad cero. Un solo loop para los 3 productos = barato.
         Se pausa fuera del viewport y en pestaña oculta. */
      if(!rm){
        var floaties=[].slice.call(root.querySelectorAll('.vhx__floaty'));
        for(var f=0;f<floaties.length;f++){
          floaties[f]._p={
            ax:6+Math.random()*5, ay:11+Math.random()*8, ar:1+Math.random()*1.2,
            wx:0.16+Math.random()*0.12, wy:0.13+Math.random()*0.09, wy2:0.31+Math.random()*0.16,
            wr:0.1+Math.random()*0.08,
            px:Math.random()*6.283, py:Math.random()*6.283, py2:Math.random()*6.283, pr:Math.random()*6.283
          };
        }
        var raf=null, t0=null, vis=true;
        function frame(ts){
          if(t0===null) t0=ts;
          var t=(ts-t0)/1000;
          for(var k=0;k<floaties.length;k++){
            var p=floaties[k]._p;
            var y=p.ay*(0.6*Math.sin(t*p.wy+p.py)+0.4*Math.sin(t*p.wy2+p.py2));
            var x=p.ax*Math.sin(t*p.wx+p.px);
            var r=p.ar*Math.sin(t*p.wr+p.pr);
            floaties[k].style.transform='translate3d('+x.toFixed(2)+'px,'+y.toFixed(2)+'px,0) rotate('+r.toFixed(2)+'deg)';
          }
          raf=requestAnimationFrame(frame);
        }
        function playFloat(){ if(!raf&&vis){ t0=null; raf=requestAnimationFrame(frame); } }
        function pauseFloat(){ if(raf){ cancelAnimationFrame(raf); raf=null; } }
        document.addEventListener('visibilitychange',function(){ document.hidden?pauseFloat():playFloat(); });
        if('IntersectionObserver' in window){
          new IntersectionObserver(function(es){
            vis=es[0].isIntersecting;
            vis?playFloat():pauseFloat();
          },{threshold:0}).observe(root);
        } else { playFloat(); }
        playFloat();
      }
    }
    var nodes=document.querySelectorAll('.vhx[data-vhx]');
    for(var n=0;n<nodes.length;n++) init(nodes[n]);
  })();

/* ── hero LIQUID ── */
(function(){
    var root=document.currentScript && document.currentScript.previousElementSibling;
    // fallback: buscar la sección
    if(!root || !root.classList || !root.classList.contains('vlh')){ root=document.querySelector('.vlh[data-vlh]'); }
    if(!root || root.__vlh) return; root.__vlh=true;
    var rm=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(rm){ root.classList.add('vlh--rm','is-in'); return; }

    // orbes suaves de ambiente
    var ORB=['radial-gradient(circle,rgba(139,63,194,.5) 0%,rgba(91,31,138,.22) 45%,transparent 72%)',
             'radial-gradient(circle,rgba(217,70,174,.42) 0%,rgba(139,63,194,.18) 45%,transparent 72%)'];
    var fx=document.createElement('div'); fx.className='vlh__fx';
    for(var q=0;q<5;q++){
      var o=document.createElement('span'); o.className='vlh__orb';
      var size=(90+Math.random()*120).toFixed(0);
      o.style.width=size+'px'; o.style.height=size+'px';
      o.style.left=(Math.random()*100).toFixed(2)+'%'; o.style.top=(Math.random()*100).toFixed(2)+'%';
      o.style.background=ORB[q%ORB.length]; o.style.filter='blur(26px)';
      o.style.setProperty('--o',(0.28+Math.random()*0.24).toFixed(2));
      o.style.setProperty('--d',(7+Math.random()*5).toFixed(1)+'s');
      o.style.setProperty('--dy',(14+Math.random()*9).toFixed(1)+'s');
      o.style.setProperty('--dx',((Math.random()*2-1)*18).toFixed(1)+'px');
      o.style.setProperty('--delay','-'+(Math.random()*9).toFixed(1)+'s');
      fx.appendChild(o);
    }
    root.insertBefore(fx, root.querySelector('.vlh__inner'));

    // disparar entrada
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ root.classList.add('is-in'); }); });

    // levitación orgánica (rAF), pausada fuera de viewport
    var floaty=root.querySelector('.vlh__floaty');
    if(floaty){
      var p={ax:6+Math.random()*5, ay:11+Math.random()*8, ar:1+Math.random()*1.2,
        wx:0.16+Math.random()*0.12, wy:0.13+Math.random()*0.09, wy2:0.31+Math.random()*0.16, wr:0.1+Math.random()*0.08,
        px:Math.random()*6.283, py:Math.random()*6.283, py2:Math.random()*6.283, pr:Math.random()*6.283};
      var raf=null,t0=null,vis=true;
      function frame(ts){ if(t0===null)t0=ts; var t=(ts-t0)/1000;
        var y=p.ay*(0.6*Math.sin(t*p.wy+p.py)+0.4*Math.sin(t*p.wy2+p.py2));
        var x=p.ax*Math.sin(t*p.wx+p.px); var r=p.ar*Math.sin(t*p.wr+p.pr);
        floaty.style.transform='translate3d('+x.toFixed(2)+'px,'+y.toFixed(2)+'px,0) rotate('+r.toFixed(2)+'deg)';
        raf=requestAnimationFrame(frame); }
      function play(){ if(!raf&&vis){ t0=null; raf=requestAnimationFrame(frame); } }
      function pause(){ if(raf){ cancelAnimationFrame(raf); raf=null; } }
      document.addEventListener('visibilitychange',function(){ document.hidden?pause():play(); });
      if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ vis=es[0].isIntersecting; vis?play():pause(); },{threshold:0}).observe(root); }
      play();
    }

    /* Rotación de slogans (headline + subline) cada ~18s con transición suave */
    var SLOGANS=[
      {h:'UN SHOT Y LA<br>NOCHE ES TUYA', s:'Energía, deseo y aguante toda la noche. Un solo shot, 100% natural.'},
      {h:'SE ACABÓ<br>QUEDAR A DEBER', s:'Aguanta lo que ella te pida y déjala pidiendo más. 100% natural, sin química.'},
      {h:'RONDA TRAS RONDA,<br>SIN BAJÓN', s:'¿Ya terminaste? Sigues listo para la revancha: la noche no se acaba hasta que tú quieras.'}
    ];
    var titleEl=root.querySelector('.vlh__title'), subEl=root.querySelector('.vlh__sub');
    if(titleEl && subEl && SLOGANS.length>1){
      var sidx=0;
      function ease(el){ el.style.transition='opacity .42s ease, transform .42s cubic-bezier(.22,.61,.36,1)'; }
      function rotate(){
        if(document.hidden) return;
        sidx=(sidx+1)%SLOGANS.length;
        ease(titleEl); ease(subEl);
        titleEl.style.opacity='0'; titleEl.style.transform='translateY(-12px)';
        subEl.style.opacity='0'; subEl.style.transform='translateY(-12px)';
        setTimeout(function(){
          titleEl.style.transition='none'; subEl.style.transition='none';
          titleEl.style.transform='translateY(14px)'; subEl.style.transform='translateY(14px)';
          titleEl.innerHTML=SLOGANS[sidx].h; subEl.textContent=SLOGANS[sidx].s;
          void titleEl.offsetWidth;
          ease(titleEl); ease(subEl);
          titleEl.style.opacity='1'; titleEl.style.transform='translateY(0)';
          subEl.style.opacity='1'; subEl.style.transform='translateY(0)';
        },430);
      }
      setInterval(rotate, 18000);
    }
  })();

/* ── reloj FOMO (antes inline en theme.liquid) ── */
(function(){
      if (window.__vivaxFomoInit) return; window.__vivaxFomoInit = true;
      var KEY = 'vivax_carrito_reserva', MIN = 15, memExp = 0;
      function getExpiry(){
        var raw = null; try { raw = localStorage.getItem(KEY); } catch(e){}
        var exp = raw ? parseInt(raw, 10) : memExp, t = Date.now();
        if (!exp || isNaN(exp) || exp <= t){
          exp = t + MIN * 60 * 1000;
          try { localStorage.setItem(KEY, String(exp)); } catch(e){}
        }
        memExp = exp; return exp;
      }
      function tick(){
        var els = document.querySelectorAll('[data-fomo-timer]'); if (!els.length) return;
        var rem = Math.max(0, getExpiry() - Date.now());
        var m = Math.floor(rem / 60000), s = Math.floor((rem % 60000) / 1000);
        var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        for (var i = 0; i < els.length; i++) if (els[i].textContent !== txt) els[i].textContent = txt;
      }
      tick(); setInterval(tick, 1000);
      /* Cuando el carrito se re-renderiza, pintar de inmediato (no esperar al siguiente segundo). */
      var tmr = null;
      new MutationObserver(function(){ clearTimeout(tmr); tmr = setTimeout(tick, 60); })
        .observe(document.documentElement, { childList: true, subtree: true });
    })();

/* ── confetti envío gratis (antes inline en theme.liquid) ── */
(function(){
      if (window.__vivaxConfettiInit) return; window.__vivaxConfettiInit = true;
      var SS = 'vivax_envio_celebrado', ultimo = null;
      function reducido(){ try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){ return false; } }
      function confetti(origen){
        if (reducido()) return;
        var c = document.createElement('canvas'), dpr = Math.min(window.devicePixelRatio || 1, 2);
        c.setAttribute('aria-hidden','true');
        c.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000';
        c.width = innerWidth * dpr; c.height = innerHeight * dpr; document.body.appendChild(c);
        var ctx = c.getContext('2d'); ctx.scale(dpr, dpr);
        var cols = ['#5B1F8A','#8B3FC2','#D946AE','#F5A0DE','#FFD166','#FFFFFF'];
        var N = innerWidth < 600 ? 80 : 120, P = [], ox = origen.x, oy = origen.y;
        for (var i = 0; i < N; i++){
          var ang = -Math.PI/2 + (Math.random() - .5) * 1.9, v = 9 + Math.random() * 9;
          P.push({ x: ox + (Math.random()-.5)*40, y: oy, vx: Math.cos(ang)*v, vy: Math.sin(ang)*v, g: .28 + Math.random()*.12,
                   w: 5 + Math.random()*6, h: 3 + Math.random()*4, r: Math.random()*6.28, vr: (Math.random()-.5)*.35,
                   col: cols[i % cols.length], circ: Math.random() < .25 });
        }
        var t0 = performance.now(), DUR = 1700;
        function frame(t){
          var k = (t - t0) / DUR; ctx.clearRect(0, 0, innerWidth, innerHeight);
          for (var j = 0; j < P.length; j++){ var p = P[j];
            p.vy += p.g; p.vx *= .985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
            ctx.globalAlpha = k > .7 ? Math.max(0, 1 - (k - .7) / .3) : 1;
            ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.col;
            if (p.circ){ ctx.beginPath(); ctx.arc(0, 0, p.h, 0, 6.28); ctx.fill(); } else ctx.fillRect(-p.w/2, -p.h/2, p.w, p.h);
            ctx.restore();
          }
          if (k < 1) requestAnimationFrame(frame); else c.remove();
        }
        requestAnimationFrame(frame);
      }
      function revisar(){
        var el = document.querySelector('[data-envio-listo]');
        if (!el){ return; }
        var listo = el.getAttribute('data-envio-listo') === 'true';
        var celebrado = false; try { celebrado = sessionStorage.getItem(SS) === '1'; } catch(e){}
        if (listo && !celebrado && ultimo === false){
          var b = el.getBoundingClientRect();
          var visible = b.width > 0 && b.bottom > 0 && b.top < innerHeight;
          confetti(visible ? { x: b.left + b.width/2, y: b.top + b.height/2 } : { x: innerWidth/2, y: innerHeight*.4 });
          try { sessionStorage.setItem(SS, '1'); } catch(e){}
        }
        if (!listo){ try { sessionStorage.setItem(SS, '0'); } catch(e){} }
        ultimo = listo;
      }
      /* Sin debounce con setTimeout a propósito: en pestañas ocultas Chrome estrangula los timers
         a 1/s y, como el reloj del carrito muta el DOM cada segundo, un debounce corto puede no
         disparar nunca. revisar() cuesta un querySelector: se puede correr en cada lote de mutaciones. */
      new MutationObserver(revisar).observe(document.documentElement, { childList: true, subtree: true });
      revisar();
    })();


/* ===== VIVAX upsell del carrito (2026-09-06) — botón "+ Agregar" de snippets/vivax-carrito-upsell.liquid.
   En el drawer re-renderiza con el mismo mecanismo de Dawn (cart-drawer.renderContents + sections); en /cart recarga. ===== */
(function () {
  if (window.__vivaxUpsellInit) return; window.__vivaxUpsellInit = true;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vivax-upsell-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = Number(btn.getAttribute('data-vivax-upsell-add'));
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Agregando…';
    var drawer = document.querySelector('cart-drawer');
    var enDrawer = !!(drawer && btn.closest('cart-drawer') && typeof drawer.renderContents === 'function');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (enDrawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        if (enDrawer && j.sections) {
          drawer.classList.remove('is-empty'); // como hace product-form.js de Dawn (renderContents no lo quita del <cart-drawer>)
          drawer.renderContents(j);
          try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vivax-upsell', cartData: j }); } catch (_) {}
        } else {
          btn.classList.add('is-ok'); btn.textContent = '✓ Agregado';
          window.location.reload();
        }
      })
      .catch(function (err) {
        btn.disabled = false; btn.textContent = label;
        console.error('VIVAX upsell:', err);
      });
  });
})();

/* ── "Avísame cuando llegue" (2026-09-10) — markup en snippets/vivax-avisame.liquid ── */
(function () {
  if (window.__vivaxAvisameInit) return; window.__vivaxAvisameInit = true;
  /* ⚠️ El modal se MUDA a <body> al cargar. .product__info-wrapper lleva la animación
     "scroll-trigger animate--slide-in" de Dawn, que deja un transform en el contenedor; eso
     convierte al contenedor en el marco de cualquier position:fixed de adentro → el modal
     quedaba atrapado: fuera de pantalla y DETRÁS del popup del 15% (verificado 2026-09-10). */
  function roots(){ return document.querySelectorAll('[data-vivax-avisame]'); }
  function rootDe(h){ return document.querySelector('[data-vivax-avisame][data-handle="' + h + '"]'); }
  function modalDe(h){ return document.querySelector('body > [data-avisame-modal][data-handle="' + h + '"]'); }
  function scopeOf(root){ return root.closest('product-info') || root.closest('section') || document; }
  function addBtn(root){ return scopeOf(root).querySelector('[name="add"]') || document.querySelector('.product-form__submit[name="add"]'); }
  function varianteActual(root){
    var i = scopeOf(root).querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return i ? String(i.value) : '';
  }
  function ya(h){ try { return localStorage.getItem('vivax_avisame_' + h) === '1'; } catch(e){ return false; } }
  function portal(){
    roots().forEach(function(root){
      var m = root.querySelector('[data-avisame-modal]'); if (!m) return; // ya se mudó
      var h = root.getAttribute('data-handle');
      var viejo = modalDe(h); if (viejo) viejo.remove(); // si Dawn re-renderizó el bloque, no duplicar el form
      m.setAttribute('data-handle', h);
      document.body.appendChild(m);
    });
  }
  // Muestra el botón solo si el de compra está deshabilitado (variante agotada).
  // ⚠️ No escribir nada que dispare el MutationObserver en bucle: solo 'hidden' y un data-attr.
  function sync(){
    portal();
    roots().forEach(function(root){
      var btn = root.querySelector('[data-avisame-open]'); if (!btn) return;
      var a = addBtn(root), agotado = a ? a.disabled : true;
      btn.hidden = !agotado;
      // La clase oculta (por CSS) el "Llévate 2" y el "Pídelo hoy…": no prometer nada de algo sin stock.
      document.documentElement.classList.toggle('vivax-agotado', agotado);
      // La barra fija decía "Agregar" y hacía click al botón de compra DESHABILITADO (botón muerto).
      var st = document.querySelector('.vivax-sticky-atc__button'), modo = agotado ? 'avisame' : 'agregar';
      if (st && st.getAttribute('data-modo') !== modo) {
        if (!st.hasAttribute('data-txt-orig')) st.setAttribute('data-txt-orig', st.textContent.trim());
        st.setAttribute('data-modo', modo);
        st.textContent = agotado ? '🔔 Avísame' : st.getAttribute('data-txt-orig');
      }
      if (ya(root.getAttribute('data-handle')) && !btn.hasAttribute('data-done')) {
        btn.setAttribute('data-done', '');
        btn.innerHTML = '<span aria-hidden="true">✅</span> Ya te avisaremos · cambiar';
      }
    });
  }
  var lockY = 0;
  function open(h, ok){
    var m = modalDe(h), root = rootDe(h); if (!m) return;
    m.querySelector('[data-avisame-form-view]').hidden = !!ok;
    m.querySelector('[data-avisame-ok-view]').hidden = !ok;
    if (!ok && root) {
      var sel = m.querySelector('[data-avisame-sabor]'), vid = varianteActual(root);
      if (sel && vid) for (var k = 0; k < sel.options.length; k++) if (sel.options[k].getAttribute('data-variant-id') === vid) { sel.selectedIndex = k; break; }
    }
    m.classList.add('is-open');
    lockY = window.scrollY || 0;
    document.body.style.position = 'fixed'; document.body.style.top = (-lockY) + 'px'; document.body.style.width = '100%';
    if (!ok) { var f = m.querySelector('input[type=email]'); if (f) setTimeout(function(){ try { f.focus({ preventScroll: true }); } catch(e){} }, 80); }
  }
  function close(m){
    if (!m || !m.classList.contains('is-open')) return;
    m.classList.remove('is-open');
    document.body.style.position = ''; document.body.style.top = ''; document.body.style.width = '';
    window.scrollTo(0, lockY);
  }
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var o = e.target.closest('[data-avisame-open]');
    if (o) { e.preventDefault(); portal(); open(o.closest('[data-vivax-avisame]').getAttribute('data-handle'), false); return; }
    var c = e.target.closest('[data-avisame-close]');
    if (c) { e.preventDefault(); close(c.closest('[data-avisame-modal]')); }
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') document.querySelectorAll('[data-avisame-modal].is-open').forEach(close);
  });
  // Fase de CAPTURA en document: corre ANTES del listener propio de la barra (que haría submitBtn.click()).
  document.addEventListener('click', function(e){
    var st = e.target.closest && e.target.closest('.vivax-sticky-atc__button');
    if (!st || st.getAttribute('data-modo') !== 'avisame') return;
    e.preventDefault(); e.stopImmediatePropagation();
    var r = document.querySelector('[data-vivax-avisame]');
    if (r) { portal(); open(r.getAttribute('data-handle'), false); }
  }, true);
  document.addEventListener('submit', function(e){
    var f = e.target; if (!f || f.id !== 'VivaxAvisame') return;
    var m = f.closest('[data-avisame-modal]'), h = m ? m.getAttribute('data-handle') : '';
    var tags = f.querySelector('[data-avisame-tags]'), sel = f.querySelector('[data-avisame-sabor]');
    var sabor = sel && sel.value ? sel.value : '';
    if (tags) tags.value = tags.getAttribute('data-base') + (sabor ? ', aviso-sabor-' + sabor : '');
    try {
      localStorage.setItem('vivax_avisame_' + h, '1');
      localStorage.setItem('vivax_avisame_sabor', sabor ? sel.options[sel.selectedIndex].text : '');
      localStorage.setItem('vivax_avisame_pending', '1');
    } catch(err){}
    // sin preventDefault: POST nativo a /contact (lo único confiable, igual que el popup)
  }, true);
  function init(){
    sync();
    roots().forEach(function(root){
      var sc = scopeOf(root);
      try { new MutationObserver(sync).observe(sc === document ? document.body : sc, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] }); } catch(e){}
    });
    var pend = false; try { pend = localStorage.getItem('vivax_avisame_pending') === '1'; } catch(e){}
    if (location.search.indexOf('customer_posted=true') >= 0 && (location.hash === '#VivaxAvisame' || pend)) {
      var root = document.querySelector('[data-vivax-avisame]');
      if (root) {
        var h = root.getAttribute('data-handle'), m = modalDe(h), s = '';
        try { s = localStorage.getItem('vivax_avisame_sabor') || ''; } catch(e){}
        var span = m && m.querySelector('[data-avisame-ok-sabor]'); if (span) span.textContent = s ? ' el sabor ' + s : '';  // "…vuelva el sabor Mora (Frío)." (antes salía "(sabor Mora (Frío))")
        open(h, true);
      }
    }
    try { localStorage.removeItem('vivax_avisame_pending'); } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
